import React, {Component} from 'react';
import './logo.scss';
import logo from './logo.svg';

export default class Logo extends Component
{
    render() {
        return (
            <img src={logo} className="Logo" alt={"Zahrady Dostál"} />
        );
    }
}